const nonEmptyString = (value) => (
  typeof value === "string" && value.trim() ? value.trim() : null
);

export const normalizeErrorDetail = (detail, fallback) => {
  const directMessage = nonEmptyString(detail);
  if (directMessage) return directMessage;

  if (Array.isArray(detail)) {
    const messages = detail
      .map((issue) => nonEmptyString(issue?.msg))
      .filter(Boolean);
    if (messages.length) return messages.join(". ");
  }

  if (detail && typeof detail === "object") {
    const objectMessage = nonEmptyString(detail.msg) || nonEmptyString(detail.message);
    if (objectMessage) return objectMessage;
  }

  return fallback;
};

export const getApiErrorMessage = (error, fallback) => {
  const detail = error?.response?.data?.detail;
  const normalizedDetail = normalizeErrorDetail(detail, null);
  if (normalizedDetail) return normalizedDetail;

  return nonEmptyString(error?.message) || fallback;
};
